import { createTheme, type ThemeOptions } from '@mui/material/styles'
import { theme as uiKitTheme } from '@ui-kit/theme'

/** Devices palette overrides on top of ui-kit theme. */
const theme = createTheme(uiKitTheme as unknown as ThemeOptions, {
  typography: {
    h1: { textTransform: 'uppercase' },
    h2: { textTransform: 'uppercase' },
    h4: { textTransform: 'uppercase' },
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
  },
  palette: {
    primary: {
      main: '#071a2a',
      light: '#3A72C3',
      dark: '#488ACB',
      blue: '#1CB6D5',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#3A72C3',
      blue: '#3A72C3',
    },
    header: {
      globalNavBackground: '#222222',
      globalNavText: '#B3B5BD',
    },
  },
  text: {
    primary: {
      dark: '#242467',
      other: '#FFFFFF',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 820,
      lg: 1140,
      xl: 1320,
    },
  },
})

export default theme
